import { LocationStrategy } from "@angular/common";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IBaseModel } from "../models/base.model";
import { IPapeisTrabalhoModel } from "../models/papeis-trabalho-model";
import { BaseService } from "./base.service";
import { FiltroPapeisTrabalho } from "../models/filtro-papeis-trabalho";

@Injectable({
    providedIn: 'root',
})
export class PapeisTrabalhoService extends BaseService {


    constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
        super(httpClient, locationStrategy);
    }

    public obter(filtro: FiltroPapeisTrabalho): Promise<IBaseModel<IPapeisTrabalhoModel[]>> {
        let params = new HttpParams();
        params = params.append('pesquisa', filtro.pesquisa);
        params = params.append('idSituacao', filtro.idSituacao.toString());
        params = params.append('idTipo', filtro.idTipo.toString());
        params = params.append('idFase', filtro.idFase.toString());
        params = params.append('idPapelAceitavel', filtro.idPapelAceitavel.toString());
        if (filtro.ativo != undefined)
            params = params.append('ativo', filtro.ativo.toString());

        return this.httpClient
            .get<IBaseModel<IPapeisTrabalhoModel[]>>(`${this.apiBaseUrl}/papeistrabalho`, { params })
            .toPromise();
    }

    public async inserir(models: IPapeisTrabalhoModel[], removidos: IPapeisTrabalhoModel[], idPlanejamento: number = 0): Promise<IBaseModel<void>> {
        return this.httpClient
            .post<IBaseModel<void>>(`${this.apiBaseUrl}/papeistrabalho`, { inserir: models, remover: removidos, idPlanejamento: idPlanejamento } )
            .toPromise();
    }

    public async obterPorId(id: number): Promise<IBaseModel<IPapeisTrabalhoModel>> {
        return this.httpClient
            .get<IBaseModel<IPapeisTrabalhoModel>>(`${this.apiBaseUrl}/papeistrabalho/${id}`)
            .toPromise();
    }

    public async atualizar(data: IPapeisTrabalhoModel): Promise<IBaseModel<void>> {
        return this.httpClient
          .put<IBaseModel<void>>(`${this.apiBaseUrl}/papeistrabalho/${data.id}`, data)
          .toPromise();
      }

    public async reativar(id: number): Promise<IBaseModel<void>> {
        return this.httpClient
            .patch<IBaseModel<void>>(`${this.apiBaseUrl}/papeistrabalho/${id}/reativar`, {})
            .toPromise();
    }

    public async inativar(id: number): Promise<IBaseModel<void>> {
        return this.httpClient
            .patch<IBaseModel<void>>(`${this.apiBaseUrl}/papeistrabalho/${id}/inativar`, {})
            .toPromise();
    }

    public async excluir(id: number, idPlanejamento: number = 0): Promise<IBaseModel<void>> {
        return this.httpClient
            .delete<IBaseModel<void>>(`${this.apiBaseUrl}/papeistrabalho/${id}/${idPlanejamento}/excluir`, { })
            .toPromise();
    }

    public async obterPorAgrupamento(id: number): Promise<IBaseModel<IPapeisTrabalhoModel[]>> {
        return this.httpClient
            .get<IBaseModel<IPapeisTrabalhoModel[]>>(`${this.apiBaseUrl}/papeistrabalho/${id}`)
            .toPromise();
    }
}